import React, {Component} from 'react';

export class SignaturePzbad extends Component {


    render() {
     const {state, copyBoxRef, language} = this.props;

    return (
        <div style={{fontSize: 8+'pt', fontFamily: 'arial, sans-serif'}} className="copyBox" ref={copyBoxRef}>
        <table style={{width:525+'px', fontSize:8+'pt', fontFamily:'Arial, sans-serif'}} cellPadding="0" cellSpacing="0">
          <tbody>
          <tr>
            <td style={{fontSize:16+'px', fontFamily:'Arial, sans-serif', color:'#2a2a2a', width:326+'px', verticalAlign:'top'}}
                valign="top">
              <strong><p style={{fontFamily:'Arial, sans-serif', color:'#264f87',fontSize:14+'px',lineHeight: 1+'px'}}>{state.name}</p></strong>
              <p style={{fontFamily:'Arial, sans-serif', fontSize:14+'px', color:'#264f87',lineHeight: 1+'px'}}>{state.jobTitle}</p>
            </td>
              <td style={{fontSize: 8+'pt',width: 199+'px', paddingRight: 10+'px', verticalAlign: 'top', textAlign: 'center', paddingBottom: 0}}
                  valign="top" rowSpan="3" align="center">
                  <a href="https://pzbad.pl" target="_blank" rel="noopener">
                      <img border="0" alt="logo" width="169"
                           style={{width:169+'px', height:'auto', border:0}}
                           src="https://static.pzbad.pl/pzbad.png"/>
                  </a><br/>
                  <span>
                    <a href="https://www.facebook.com/polskizwiazekbadmintona" target="_blank" rel="noopener">
                        <img border="0" width="23"
                             alt="facebook icon"
                             style={{border:0, height:23+'px', width:23+'px'}}
                             src="https://static.pzbad.pl/fb.png"
                        />
                    </a>&nbsp;
                </span>
                  <span>
                    <a href="https://www.youtube.com/user/pzbad" target="_blank" rel="noopener">
                        <img border="0" width="23"
                             alt="youtube icon"
                             style={{border:0, height:23+'px', width:23+'px'}}
                             src="https://static.pzbad.pl/yt.png"
                        />
                    </a>&nbsp;
                </span>
                  <span>
                    <a href="https://www.instagram.com/pzbad/" target="_blank" rel="noopener">
                        <img border="0" width="23"
                             alt="instagram icon"
                             style={{border:0, height:23+'px', width:23+'px'}}
                             src="https://static.pzbad.pl/it.png"
                        />
                    </a>&nbsp;
                </span>
              </td>
          </tr>

          <tr>
            <td style={{fontSize:10+'pt', fontFamily:'Arial, sans-serif', color:'#8c8c8c', width:326+'px', verticalAlign:'top'}}
                valign="top">
                <p style={{fontFamily:'Arial, sans-serif', fontSize:10+'pt', color:'#8c8c8c',lineHeight: 10+'pt'}}>
                    {language ? 'Polski Związek Badmintona' : 'Polish Badminton Association (PBA)' }<br/>Biuro Flex na PGE Narodowy<br />
                    <strong>Klatka 4, Piętro 1</strong><br />
                    ul. Al.Ks.J Poniatowskiego 1,<br/>03-901 Warszawa<br/>NIP: 113-035-47-60<br /><br/>
                    {language ? 'Telefon:' : 'Phone:' } {state.cellphone}{state.phone && <span>, {state.phone}</span>}<br/>
                    E-mail: {state.mail}<br/>
                    <strong>
                        <a href="https://pzbad.pl" target="_blank" rel="noopener"
                           style={{textDecoration:'none'}}><span
                            style={{fontFamily:'Arial, sans-serif', fontSize:10+'pt', color:'#8c8c8c'}}>www.pzbad.pl</span></a>
                    </strong><br/><br/>
                </p>
            </td>

          </tr>
          <tr>
              <td colSpan='2'><span><hr/></span></td>
          </tr>
          <tr>
              <td colSpan='2' style={{
                  fontSize: 10 + 'pt',
                  fontFamily: 'Arial, sans-serif',
                  color: '#264f87',
                  lineHeight: 10 + 'pt',
                  width: 700 + 'px',
                  paddingRight: 10 + 'px',
                  verticalAlign: 'bottom',
                  textAlign: 'center'
              }}>
                  <img border="0" width="700"
                       alt="Polish Open 2024"
                       src="https://static.pzbad.pl/footer-12.2025.jpg"/>
              </td>
          </tr>
          <tr>
              <td colSpan='2'><span><hr/></span></td>
          </tr>
          <tr>
              {language && <td style={{fontSize:8+'pt', fontFamily:'Arial, sans-serif', color:'#2a2a2a', paddingTop:10+'px', textAlign:'justify', verticalAlign:'top',lineHeight: 10+'pt'}}
                align="justify" valign="top" colSpan="2">
   <span style={{fontFamily:'Arial, sans-serif', fontSize:8+'pt', color:'#999999',lineHeight: 8+'pt'}}>Zanim wydrukujesz tą wiadomość pomyśl o środowisku.<br/><br/>

Zgodnie z art. 13 ust. 1 i ust. 2 Ogólnego rozporządzenia Parlamentu i Rady Unii Europejskiej o ochronie danych osobowych z dnia 27 kwietnia 2016 r.
informujemy, że: <br/><br/>
Administratorem Danych Osobowych jest Polski Związek Badmintona z siedzibą przy ul. Al.Ks.J Poniatowskiego 1, 03-901 Warszawa, wpisany
do Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla m. st. Warszawy w Warszawie, XII Wydział Gospodarczy, pod numerem KRS: 000061704, NIP: 113-035-47-60, e-mail:
sekretariat@pzbad.pl, tel. +48 575 905 675; podanie przez Pana/Panią danych osobowych w korespondencji mailowej jest dobrowolne, lecz niezbędne
do celów udzielenia odpowiedzi na przedstawione zagadnienie; przetwarzanie Pana/Pani danych osobowych w celu udzielenia odpowiedzi na przedstawione zagadnienie,
co stanowi nasze uzasadnione interesy i odbywa się na podstawie art. 6 ust. 1 lit. f) Ogólnego Rozporządzenia Parlamentu i Rady Unii Europejskiej o ochronie danych
osobowych z dnia 27 kwietnia 2016 r. i zgodnie z zasadami określonymi w niniejszym Rozporządzeniu;
Więcej informacji znajdziecie Państwo w Informacji o przetwarzaniu danych osobowych
       <br/></span>
                <div style={{fontFamily:'Arial, sans-serif', fontSize:8+'pt', color:'#999999', textAlign: 'center'}}>
********UWAGA********
                </div>

                <span style={{fontFamily:'Arial, sans-serif', fontSize:8+'pt', color:'#999999'}}>
Niniejsza wiadomość wraz z ewentualnymi załącznikami zawiera poufną korespondencję. Jeżeli odbiorca tej wiadomości nie jest jej adresatem,
informujemy, że otrzymali ją Państwo omyłkowo oraz że jej rozpowszechnianie lub kopiowanie jest zabronione. W przypadku omyłkowego otrzymania
niniejszej wiadomości prosimy o niezwłoczne powiadomienie nas o tym telefonicznie (+48 575 905 675) oraz o niezwłoczne usunięcie otrzymanej
wiadomości oraz ewentualnych załączników. Dziękujemy.</span>
            </td>}
              {!language && <td style={{fontSize:8+'pt', fontFamily:'Arial, sans-serif', color:'#2a2a2a', paddingTop:10+'px', textAlign:'justify', verticalAlign:'top',lineHeight: 10+'pt'}}
                               align="justify" valign="top" colSpan="2">
                  <span style={{fontFamily:'Arial, sans-serif', fontSize:8+'pt', color:'#999999',lineHeight: 8+'pt'}}>
                      The message is intended only dor the recipient named above, Access to this message by anyone else is prohibited.
                      if you are not the intended recipient, you are hereby notfied that any dissemination, distribution or copying of,
                      or any similar action with respect to this message is prohibited  and may be illegal. Please notify the sender of
                      the receipt of this message and delete it without opening the attachments.
                  </span>

              </td>}

          </tr>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/Components/SignaturePzbad.js